    var content5 = document.getElementById("content_one1").innerText;
		var text5 = document.getElementById("text_one1");
		var CopyBtn5 = document.getElementById("CopyBtn_one1");
		CopyBtn5.onclick = function(){
			text5.value = content;
			text5.select();
			document.execCommand("copy");
			alert(content5 + " Copy successfully");
		}
		var content6 = document.getElementById("content_two1").innerText;
		var text6 = document.getElementById("text_two1");
		var CopyBtn6 = document.getElementById("CopyBtn_two1");
		CopyBtn6.onclick = function(){
			text6.value = content1;
			text6.select();
			document.execCommand("copy");
			alert(content6 + " Copy successfully");
		}
        var content7 = document.getElementById("content_three1").innerText;
		var text7 = document.getElementById("text_three1");
		var CopyBtn7 = document.getElementById("CopyBtn_three1");
		CopyBtn7.onclick = function(){
			text7.value = content2;
			text7.select();
			document.execCommand("copy");
			alert(content7 + " Copy successfully");
		}
        var content8 = document.getElementById("content_four1").innerText;
		var text8 = document.getElementById("text_four1");
		var CopyBtn8 = document.getElementById("CopyBtn_four1");
		CopyBtn8.onclick = function(){
			text8.value = content3;
			text8.select();
			document.execCommand("copy");
			alert(content8 + " Copy successfully");
		}
        